import { useState } from "react";
import { toast } from "sonner";
import { Copy, ExternalLink, FileDown, MessageSquareShare, Trash2, Link2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { buildLink, deckById, directLink, shareMessage } from "./deckRegistry";
import { lastNedPdf } from "./LinkBuilder";

const fmtDato = (iso) => {
  try { return new Date(iso).toLocaleDateString("nb-NO", { day: "numeric", month: "short" }); } catch { return ""; }
};

const kopier = (tekst, melding) =>
  navigator.clipboard.writeText(tekst).then(() => toast.success(melding)).catch(() => toast.error("Kunne ikke kopiere"));

const Rad = ({ l, password, onDeleted }) => {
  const deck = deckById(l.deck);
  const [busy, setBusy] = useState(false);
  if (!deck) return null;
  const link = buildLink(deck, l.token);
  const direkte = directLink(deck, l.token);
  const slett = async () => {
    if (!window.confirm(`Fjerne ${l.mottaker} fra listen?`)) return;
    try { await api.delete(`/admin/deck-lenker/${l.id}`); onDeleted(); } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="pdadm-row" data-testid={`pdadm-lenke-${l.id}`}>
      <span className={`pdadm-deckdot d-${deck.id}`} title={deck.name}>{deck.nr}</span>
      <div className="min-w-0">
        <p className="n truncate">{l.mottaker}</p>
        <p className="m truncate">{deck.name}{l.kategori ? ` · ${l.kategori}` : ""}{l.createdAt ? ` · ${fmtDato(l.createdAt)}` : ""}</p>
      </div>
      <a href={link} target="_blank" rel="noreferrer" className="pdadm-row-url" title={link} data-testid={`pdadm-lenke-url-${l.id}`}>
        <Link2 size={11} /><span className="truncate">{link.replace(/^https?:\/\/[^/]+/, "")}</span>
      </a>
      <div className="pdadm-row-actions">
        <button type="button" className="adm-btn-ghost adm-btn-sm" onClick={() => kopier(link, `Lenke til ${l.mottaker} kopiert`)} data-testid={`pdadm-lenke-kopier-${l.id}`}><Copy size={12} /> Lenke</button>
        <button type="button" className="adm-btn-ghost adm-btn-sm" onClick={() => kopier(shareMessage(deck, l.mottaker, link, password), "Lenke + passord kopiert")} data-testid={`pdadm-lenke-melding-${l.id}`}><MessageSquareShare size={12} /> + passord</button>
        <a className="adm-btn-ghost adm-btn-sm" href={direkte} target="_blank" rel="noreferrer" data-testid={`pdadm-lenke-aapne-${l.id}`}><ExternalLink size={12} /></a>
        <button type="button" className="adm-btn-ghost adm-btn-sm" disabled={busy} onClick={() => lastNedPdf(deck, l.mottaker, l.kategori, setBusy)} data-testid={`pdadm-lenke-pdf-${l.id}`}><FileDown size={12} /> {busy ? "…" : "PDF"}</button>
        <button type="button" className="adm-btn-danger adm-btn-sm" onClick={slett} title="Fjern" data-testid={`pdadm-lenke-slett-${l.id}`}><Trash2 size={12} /></button>
      </div>
    </div>
  );
};

export const SavedLinks = ({ lenker, password, onChanged }) => (
  <section className="mt-10" data-testid="pdadm-saved">
    <div className="flex items-baseline justify-between gap-3">
      <p className="adm-label">Lagrede lenker</p>
      {lenker?.length > 0 && <p className="pdadm-meta" data-testid="pdadm-saved-count">{lenker.length} mottaker{lenker.length === 1 ? "" : "e"}</p>}
    </div>
    {lenker === null ? (
      <p className="pdadm-hint mt-4">Henter …</p>
    ) : lenker.length === 0 ? (
      <div className="ldadm-tom mt-4" data-testid="pdadm-saved-empty"><p>Ingen lagrede lenker ennå. Lag en over og trykk «Lagre i listen».</p></div>
    ) : (
      <div className="pdadm-rows mt-4">{lenker.map((l) => <Rad key={l.id} l={l} password={password} onDeleted={onChanged} />)}</div>
    )}
  </section>
);
